<template>
  <div class="Terminal">
    <div class="content scroll">
      <van-collapse class="scroll-a" v-model="activeNames" @change="getChea" accordion>
        <van-collapse-item v-for="(item,index) in titelData" icon="/static/images/etv-folder.png"
                           @touchstart.native.stop="gotouchstart(item,index)" @touchmove.native="gotouchmove"
                           @touchend.native="gotouchend"
                           :title="item.name" :name="index" :key="index">
          <ul class="item-child" v-if="index === activeNames">
            <li v-for="(it,i) in data" :key="i" class="Keylist">
              <span style="height: 100%;display: flex;align-items:center;">
                <img v-if="it.onlineState === '-1'" src="/static/images/icon_dev_disonline.png" alt="">
                <img v-else src="/static/images/icon_dev_online.png" alt="">
                {{ it.name }}
              </span>
              <span>
                <van-button color="#ff0000" size="mini" plain @click="deleTer(it.clNo,i)">删除</van-button>
                <van-button type="info" size="mini" @click="goto(it)">更多</van-button>
              </span>
            </li>
          </ul>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div class="btns">
      <div>
        <van-button color="#409eff" size="small" @click="reload">刷新</van-button>
        <span style="display: inline-block;width: 10px"></span>
        <van-button color="#409eff" size="small" @click="dialogShow=true">新建分组</van-button>
        <span style="display: inline-block;width: 10px"></span>
        <van-button color="#409eff" size="small" @click="scan">设备接入</van-button>
      </div>
      <div>
        <van-button color="#409eff" size="small" @click="open" plain>筛选</van-button>
      </div>
    </div>
    <nut-dialog title="新建终端分组" :visible="dialogShow" @ok-btn-click="onsubmit"
                :closeOnClickModal="false"
                @close="inputDialogClose">
      <div>
        <nut-textinput
            v-model="groupName"
            label="名称："
            placeholder="请输入组名"
            :clearBtn="false"
        />
      </div>
    </nut-dialog>
    <van-popup
        v-model="show"
        position="right"
        :get-container="getContainer"
        :style="{ height: '100%',width: '70%' }"
    >
      <div class="a">
        <div class="popup-title">
          筛选
        </div>
        <van-search
            v-model="clientName"
            placeholder="请输入搜索关键词"
            shape="round"
            @search="onSearch"
        >
        </van-search>
        <div class="popup-title">终端状态</div>
        <div class="popup-btns">
          <van-button :color="a === 1 ? '#409eff':'' " size="small" @click="getType(0,1)">全部</van-button>
          <span style="display: inline-block;width: 10px"></span>
          <van-button size="small" :color="a === 2 ? '#409eff':'' " @click="getType(1,2)">在线</van-button>
          <span style="display: inline-block;width: 10px"></span>
          <van-button :color="a === 3 ? '#409eff':'' " size="small" @click="getType(-1,3)">离线</van-button>
        </div>
        <div class="button-btns">
          <van-button color="#ff0000" @click="close" plain size="small">取消</van-button>
          <van-button color="#409eff" size="small" @click="onSearch">确定</van-button>
        </div>
      </div>
    </van-popup>
    <nut-dialog title="绑定设备" :visible="programShow" @ok-btn-click="onprogramShow"
                :closeOnClickModal="false"
                @close="inputDialogClose">
      <div class="nut-content">
        <label class="nut-label">设备名称</label>
        <input class="nut-input" type="text" v-model="deviceName" placeholder="请输入设备名称">
      </div>
      <div class="nut-content" style="margin-top: 20px">
        <label class="nut-label">设备编号</label>
        <input class="nut-input" type="text" disabled v-model="deviceNo" placeholder="请输入节目名称">
      </div>
      <div class="nut-content" style="margin-top: 20px">
        <label class="nut-label">设备分组</label>
        <input class="nut-input" type="text" @click="showPicker = true" readonly v-model="programgroupName"
               placeholder="请选择设备分组">
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
              show-toolbar
              :columns="groupingList.map(res => {
              return res.name
            })"
              title="设备分组"
              @cancel="showPicker = false"
              @confirm="onConfirm"
          ></van-picker>
        </van-popup>

      </div>
    </nut-dialog>
    <van-overlay :show="overlayShow">
      <div class="wrapper">
        <span class="close" @click="overlayShow = false">
          <van-icon name="cross"/>
        </span>
        <van-loading size="40px">调用设备，请稍等...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import qs from 'qs'
import {Dialog, Toast} from 'vant'
import {mapActions} from 'vuex'
import $ from "jquery"
import wx from "weixin-js-sdk"

export default {
  name: 'Terminal',
  inject: ['reload'],
  data() {
    return {
      activeNames: '',
      data: [],
      titelData: [],
      TerminalTop: 0,
      dataList: [],
      doch: 0,
      loading: false,
      finished: false,
      index: 0,
      dialogShow: false,
      groupName: '',
      show: false,
      onlineState: '',
      clientName: '',
      a: 1,
      timeOutEvent: 0,
      longClick: 0,
      deviceNo: '',
      programgroupName: '',
      deviceName: '',
      showPicker: false,
      programShow: false,
      groupingList: [],
      qrCodeData: {
        code: 'dasdsadsd',
      },
      programNameIndex: 0,
      overlayShow: false
    }
  },

  mounted() {
    document.title = '亿晟信发小程序'
    this.$nextTick(() => {
      var winHeight = $(window).height()
      $(window).resize(function () {
        var thisWidth = $(this).height()
        if (winHeight > thisWidth) {
          $(".nut-tabbar").hide()
        } else {
          $(".nut-tabbar").show()
        }
      })
    })

    this.doch = window.screen.height
    this.getData()
    const Terminal = document.getElementsByClassName('scroll')[0]
    Terminal.addEventListener('scroll', this.handleScroll)
    this.$ajax('/etv/getWeixinAccessToken.json').then(res => {
      if (res.data.code === 0) {
        wx.config({
          debug: false,//是否开启调试
          //  appId: 'wxf4ecc1546a053d74',//小程序appid
          appId: 'wxa12dcf325e893ef5',//小程序appid
          timestamp: res.data.data.timestamp,//时间搓，单位秒
          nonceStr: res.data.data.nonceStr,//随机字符串
          signature: res.data.data.signature,//签名md5
          jsApiList: ['scanQRCode'],
        })
      } else {
        Toast(res.data.msg)
      }
    })
  },
  methods: {
    ...mapActions(['changeTopTitle', 'changeTopIconStatus', 'setParentPage']),
    gotouchstart(item, index) {
      clearTimeout(this.timeOutEvent)//清除定时器
      this.timeOutEvent = 0
      this.longClick = 0

      if (item.id === "1") {
        return
      }

      this.timeOutEvent = setTimeout(() => {
        this.longClick = 1
        Dialog.confirm({
          title: '删除分组',
          message: '确认删除该分组吗？',
        }).then(() => {
          this.$ajax.post('/etv/deleteGroupById.json', qs.stringify({
            id: item.id,
          })).then(res => {
            if (res.data.code === 0) {
              Toast('删除成功')
              this.titelData.splice(index, 1)
            }
            Toast(res.data.msg)
          })
        }).catch(() => {
        })

      }, 700)//这里设置定时
    },
    //手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
    gotouchend() {
      clearTimeout(this.timeOutEvent)
      if (this.timeOutEvent !== 0 && this.longClick === 0) {
        return
      }
    },
    //如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
    gotouchmove() {
      clearTimeout(this.timeOutEvent)//清除定时器
      this.timeOutEvent = 0
    },
    getChea(activeNames) {
      this.index = 0
      if (activeNames === '') {
        return
      }
      this.activeNames = activeNames
      this.data = this.dataList[this.activeNames].children.slice(this.index, 15)
    },
    onprogramShow() {
      let str = this.qrCodeData.code
      if (!this.groupingList[this.programNameIndex].id) {
        Toast('请选择分组')
        return
      }

      if (this.deviceName === '') {
        Toast('请输入设备名称')
        return
      }

      this.$ajax.post('/etv/insertPhoneClient.json', qs.stringify({
        clName: this.deviceName,
        clNo: str,
        clGpId: this.groupingList[this.programNameIndex].id,
      })).then(res => {
        this.showPicker = false
        this.programShow = false
        if (res.data.code === 0) {
          Toast('添加成功')
        } else {
          Toast(res.data.msg)
        }
      })
    },
    getData(onlineState = '', clientName = '', groupParentId = '', type = '') {
      this.$ajax.post('/etv/selectSeachClientTreeMobile.json', qs.stringify({
        groupParentId,
        type,
        onlineState,
        clientName,
      })).then(res => {
        this.titelData = []
        this.dataList = []
        if (res.data.code === 0) {
          res.data.data.map((res) => {
            this.titelData.push({id: res.id, name: res.name})
          })
          this.dataList = res.data.data
        }
      })
    },
    onConfirm(value, index) {
      this.showPicker = false
      this.programgroupName = value
      this.programNameIndex = index
    },
    handleScroll() {
      //滚动条
      const scrollHeight = document.getElementsByClassName('scroll')[0].scrollTop
      let clientHeight = document.getElementsByClassName('scroll-a')[0].clientHeight
      //真实高度
      if (clientHeight - this.doch - scrollHeight + 70 < 40) {
        if (this.dataList[this.activeNames].children.slice(this.index * 15, this.index * 15 + 15).length < 15) {
          return
        }
        this.index++
        this.data = [...this.data, ...this.dataList[this.activeNames].children.slice(this.index * 15, this.index * 15 + 15)]
      }
    },

    deleTer(clNo, index) {
      Dialog.confirm({
        title: '删除设备',
        message: '确认删除该设备？',
      }).then(() => {
        this.$ajax.post('/etv/deleteClientByClNo.json', qs.stringify({
          clNos: clNo,
        })).then(res => {
          if (res.data.code === 0) {
            Toast('删除成功')
            this.data.splice(index, 1)
          }
        })
      }).catch(() => {

      })
    },

    goto(data) {
      this.changeTopTitle('终端信息')
      this.setParentPage('terminal')
      this.changeTopIconStatus(true)
      this.$router.push({path: '/tinformation', query: {id: data.clId, clNo: data.clNo}})
    },

    onsubmit() {
      this.$ajax.post('/etv/insertGroup.json', qs.stringify({
        groupName: this.groupName,
        groupParentId: -1,
        groupDescp: '',
      })).then(res => {
        if (res.data.code === 0) {
          this.reload()
        } else {
          Toast(res.data.msg)
        }
      })
    },

    getContainer() {
      return document.querySelector('.Terminal')
    },

    onSearch() {
      this.getData(this.onlineState, this.clientName)
      this.show = false
    },

    open() {
      this.show = true
    },

    close() {
      this.show = false
      this.inputDialogClose()
    },

    getType(type, num) {
      this.a = num
      this.onlineState = type
    },
    inputDialogClose() {
      this.dialogShow = false
      this.show = false
      this.groupName = ''
    },
    scan() {
      this.overlayShow = true
      this.$ajax.get('/etv/selectSeachClientTreeMobile.json').then(res => {
        if (res.data.code === 0) {
          this.groupingList = res.data.data
          this.programgroupName = res.data.data[0].name
        }
      })
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: (res) => {
          this.overlayShow = false
          try {
            this.qrCodeData = JSON.parse(res.resultStr)
          } catch (e) {
            this.qrCodeData = {
              type: 'error',
            }
          }
          if (this.qrCodeData.type !== 'bind') {
            Toast('二维码错误')
          } else if (this.qrCodeData.ip !== '119.23.220.53' && this.qrCodeData.ip !== 'etv.ids.esoncloud.com') {
            Toast('设备不支持')
          } else if (this.qrCodeData.isLine === '-1') {
            Toast('设备不在线')
          } else {
            this.deviceNo = this.qrCodeData.code
            this.deviceName = ''
            this.programShow = true
          }
        },
        fail(error) {
          console.log(error);
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.Terminal {
  height: calc(100% - 70px);

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100% - 70px);
    position: relative;

    .close {
      top: 10px;
      right: 10px;
      position: absolute;

      i {
        color: white;
      }
    }
  }

  .block {
    width: 120px;
    height: 120px;
    background-color: #fff;
  }

  .content {
    height: calc(100% - 40px);
    overflow-y: auto;

    .van-collapse-item__title--expanded {
      background: $uni-color-primary;
      color: #ffffff;
    }

    .van-collapse-item__content {
      padding: 0;
    }

    .item-child {
      list-style: none;
      padding: 0 16px;

      li {
        padding: 10px 0;
        line-height: 30px;
        position: relative;
        display: flex;
        justify-content: space-between;
        font-size: 16px;

        button {
          line-height: 22px;
        }

        img {
          height: 24px;
          margin-right: 10px;
        }

        &::after {
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          top: -50%;
          right: -50%;
          bottom: -50%;
          left: -50%;
          border-bottom: 1px solid $uni-border-bottom-color;
          -webkit-transform: scale(.5);
          transform: scale(.5);
        }
      }

      li:nth-last-child(1) {
        &::after {
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          top: -50%;
          right: -50%;
          bottom: -50%;
          left: -50%;
          border-bottom: none;
          -webkit-transform: scale(.5);
          transform: scale(.5);
        }
      }

    }
  }

  .btns {
    display: flex;
    height: 40px;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
  }

  .a {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .popup-title {
    height: 30px;
    line-height: 30px;
    background: #f1f1f1;
    padding-left: 15px;
  }

  .popup-btns {
    margin-top: 15px;
    padding: 0 15px;
  }

  .button-btns {
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  .van-button--mini {
    font-size: 14px;
    height: 30px;
    box-sizing: border-box;
  }

  .van-cell {
    line-height: 30px;
    font-size: 16px;
  }

  .van-cell__right-icon {
    color: white;
    line-height: 30px !important;
  }

  .van-cell__left-icon, .van-cell__right-icon {
    height: 30px;
    font-size: 16px;
    line-height: 30px;
    margin-right: 8px;
  }
}
</style>
